/* eslint-disable */
import { useRef, useState, useEffect } from 'react';

export const createDOMRect = (bounds) => ({
	x: bounds.x || 0,
	y: bounds.y || 0,
	width: bounds.width || 0,
	height: bounds.height || 0,
	top: bounds.top || 0,
	right: bounds.right || 0,
	bottom: bounds.bottom || 0,
	left: bounds.left || 0,
});

export function useBoundingClientRect() {
	const ref = useRef();
	const [rect, setRect] = useState(createDOMRect({}));

	useEffect(() => {
		setRect(ref.current.getBoundingClientRect());
	}, [ref.current]);

	return [ref, rect];
}

export default useBoundingClientRect;
